import { styled } from '@mui/material';

export const Container = styled('div')({
  padding: '22px',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: window.innerHeight - 294,
  overflowY: 'auto',
});

export const GranitContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '22px',
});

export const ChipContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '12px',
  alignItems: 'center',
});

export const Image = styled('img')(
  ({ isSelected, borderRadius }: { isSelected?: boolean; borderRadius?: number }) => ({
    width: '140px',
    height: '140px',
    borderRadius: borderRadius === undefined ? 5 : borderRadius,
    cursor: 'pointer',
    border: `${isSelected ? '4' : '0'}px solid #BC9A67`,
  }),
);

export const ImageContainer = styled('div')(
  ({ isSelected, imageUrl }: { imageUrl: string; isSelected?: boolean }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    width: '140px',
    height: '140px',
    borderRadius: 10,
    cursor: 'pointer',
    border: `${isSelected ? '3' : '0'}px solid #BC9A67`,
    backgroundImage: `url("${imageUrl}")`,
    backgroundSize: '140px',
    position: 'relative',
  }),
);

export const ImageNameContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#F2F4F7',
  width: '100%',
  borderBottomLeftRadius: 5,
  borderBottomRightRadius: 5,
});

// IOSSwitch removed - not used in this module

export const Row = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});
